/*
    create by BaiZhiming 2016-2-24
*/
// 权限公共服务
'use strict';
angular.module('permissionServiceModule', [])
    .factory('permissionService', ['$q', 'trsHttpService', 'globleParamsSet', function($q, trsHttpService, globleParamsSet) {
        return {
            // 当前用户是否是管理员
            isAdministrator: function(bool) {
                var deffer = $q.defer();
                var params = {
                    serviceid: 'mlf_extuser',
                    methodname: 'isAdministrator'
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post')
                    .then(function(data) {
                        var flag = data.ISADMINISTRATOR == 'true';
                        if (bool) {
                            deffer.resolve(flag);
                        } else {
                            if (flag){
                                deffer.resolve(flag);
                            } else {
                                deffer.reject();
                            }
                        }
                        
                    });
                return deffer.promise;
            },
            // 当前用户是否是租户管理员
            isTenantAdministrator: function(bool) {
                var deffer = $q.defer();
                var params = {
                    serviceid: 'mlf_extuser',
                    methodname: 'isTenantAdministrator'
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post')
                    .then(function(data) {
                        var flag = data.ISTENANTADMINISTRATOR === 'true';
                        if (bool) {
                            deffer.resolve(flag);
                        } else {
                            if (flag){
                                deffer.resolve(flag);
                            } else {
                                deffer.reject();
                            }
                        }
                    });
                return deffer.promise;
            },
            // 管理配置-产品管理-网站人口权限
            getPermissionData: function() {
                var deffer = $q.defer();
                var params = {
                    serviceid: 'mlf_metadataright',
                    methodname: 'queryCanOperOfConfiguration',
                    Classify: 'configmodule'
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post')
                    .then(function(data) {
                        deffer.resolve(globleParamsSet.handlePermissionData(data));
                    }, function(){
                        deffer.reject();
                    });
                return deffer.promise;
            }
        };
    }]);
